import React, { useEffect } from 'react';
import AuthLoading from '../components/authLoading';
import { parse as parseQuery } from 'query-string';
import { useAuthorizeAccountIdQuery } from '../../services/authService';
import AuthRetry from '../components/authRetry';
import { moveToNextScreen } from '../../utils/helpers/commonHelpers';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const Magiclink = () => {
    const navigate = useNavigate()
    const { search } = useLocation()
    const routeParams = useParams()
    const params = parseQuery(search);
    const clientId = params?.clientId || params?.client_id || routeParams?.clientId || '';
    const currentLocationId = params?.locationId || routeParams?.locationId || '';

    let accountId = '';
    if (params?.accountId) {
        try {
            accountId = atob(params.accountId);
        } catch {
            accountId = params.accountId;
        }
    } else {
        // Legacy deep link `/:clientId/:locationId` (and query-only flows) still use location as the temporary account key.
        accountId = currentLocationId || '';
    }

    const { data, isLoading, isSuccess, isFetching, isError, refetch } = useAuthorizeAccountIdQuery({
        accountId,
        locationId: currentLocationId,
        token: params?.token,
        clientId,
    }, {
        skip: !accountId,
    })

    const dispatch = useDispatch()

    useEffect(() => {
        if (isSuccess) {
            if (data?.url) {
                window.location = data.url;
                return;
            }

            const currentLocation =
                data?.locationList?.find((location) => String(location?.id) === String(currentLocationId))
                || data?.locationList?.[0];
            const nextPage = currentLocation?.showSetupAccountingButton ? '../user-onboard' : '../dashboard';

            moveToNextScreen(navigate, dispatch, nextPage, {
                ...data,
                token: data?.token || params?.token,
                clientId: data?.clientId || clientId,
            })
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess])

    return ( 
        <>
            <div style={{
                display: "flex", alignItems: 'center', justifyContent: 'center', height: '100%',
                flexDirection: 'column'
            }}>
                {(isLoading || isFetching) && <AuthLoading />}
                {isError && <AuthRetry retry={refetch} />}
            </div>
        </>
     );
}
 
export default Magiclink;